const RateTypes = ["FLAT RATE", "HOURLY RATE"];

export const RATE_TYPES = RateTypes;

const RateType = {
	flat_rate: "FLAT RATE",
	hourly_rate: "HOURLY RATE"
};

export const RATE_TYPE = RateType;

const RateTypeV2 = {
	fixed: "FIXED",
	hourly_rate: "HOURLY RATE"
};

export const RATE_TYPE_V2 = RateTypeV2;
